import {IGlobalStore} from "modules/types";


export const getOccupancy = (store: IGlobalStore) => store.here_now_users.occupants;
